import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './io-t-security.css'

const IoTSecurity = (props) => {
  return (
    <div className="io-t-security-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="IoT-Security - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/io-t-security"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="iot-hero">
        <video
          src="https://videos.pexels.com/video-files/6963744/6963744-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          poster="https://images.pexels.com/videos/6963744/pictures/preview-0.jpg"
          autoPlay="true"
          playsInline="true"
          className="iot-hero-video"
        ></video>
        <div className="iot-hero-overlay"></div>
        <div className="iot-hero-content">
          <div className="iot-hero-badge">
            <svg
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            <span>IoT Security Expertise</span>
          </div>
          <h1 className="hero-title">
            Secure Your IoT Ecosystem with Expert Testing &amp; Hardening
          </h1>
          <p className="hero-subtitle">
            Comprehensive security assessments for connected devices, firmware
            analysis, and ecosystem protection against evolving cyber threats.
          </p>
          <div className="iot-hero-actions">
            <a href="#contact">
              <div className="btn-primary btn btn-lg">
                <span>Request IoT Assessment</span>
              </div>
            </a>
            <a href="#services">
              <div className="btn btn-lg btn-outline">
                <span style={{ color: 'black' }}>Explore Services</span>
              </div>
            </a>
          </div>
          <div className="iot-hero-stats">
            <div className="iot-hero-stat">
              <span className="iot-hero-stat-value">500+</span>
              <span className="iot-hero-stat-label">Devices Secured</span>
            </div>
            <div className="iot-hero-stat">
              <span className="iot-hero-stat-value">98%</span>
              <span className="iot-hero-stat-label">Threat Detection</span>
            </div>
            <div className="iot-hero-stat">
              <span className="iot-hero-stat-value">24/7</span>
              <span className="iot-hero-stat-label">Monitoring</span>
            </div>
          </div>
        </div>
      </section>
      <section className="iot-overview">
        <div className="iot-overview-container">
          <div className="iot-overview-header">
            <h2 className="section-title">
              Understanding IoT Security Landscape
            </h2>
            <p className="section-subtitle">
              Comprehensive risk assessment and threat mitigation for connected
              ecosystems
            </p>
          </div>
          <div className="iot-overview-grid">
            <div className="iot-overview-card">
              <div className="iot-overview-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="iot-overview-title">IoT Risk Assessment</h3>
              <p className="section-content">
                Identify vulnerabilities across your entire IoT infrastructure
                including device firmware, network protocols, cloud
                integrations, and data flows. We map attack surfaces and
                prioritize risks based on business impact.
              </p>
              <div className="iot-overview-metrics">
                <span className="iot-overview-metric">Device Profiling</span>
                <span className="iot-overview-metric">
                  Attack Surface Mapping
                </span>
                <span className="iot-overview-metric">Risk Prioritization</span>
              </div>
            </div>
            <div className="iot-overview-card">
              <div className="iot-overview-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iot-overview-title">Threat Landscape Analysis</h3>
              <p className="section-content">
                Stay ahead of emerging IoT threats with real-time intelligence.
                Our team analyzes botnet activities, zero-day exploits, supply
                chain attacks, and manufacturer vulnerabilities specific to your
                device ecosystem.
              </p>
              <div className="iot-overview-metrics">
                <span className="iot-overview-metric">Threat Intelligence</span>
                <span className="iot-overview-metric">Zero-Day Monitoring</span>
                <span className="iot-overview-metric">Vendor Tracking</span>
              </div>
            </div>
            <div className="iot-overview-card">
              <div className="iot-overview-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path
                      d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="iot-overview-title">
                Testing &amp; Hardening Approach
              </h3>
              <p className="section-content">
                Multi-layered security testing methodology covering hardware,
                firmware, communication protocols, mobile apps, and cloud
                backends. We deliver actionable remediation guidance with
                proof-of-concept exploits.
              </p>
              <div className="iot-overview-metrics">
                <span className="iot-overview-metric">Multi-Layer Testing</span>
                <span className="iot-overview-metric">PoC Exploits</span>
                <span className="iot-overview-metric">Remediation Plans</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="iot-vulnerability">
        <div className="iot-vulnerability-container">
          <div className="iot-vulnerability-header">
            <h2 className="section-title">Vulnerability Discovery Process</h2>
            <p className="section-subtitle">
              Systematic identification of security weaknesses across your IoT
              ecosystem
            </p>
          </div>
          <div className="iot-vulnerability-steps">
            <div className="iot-vulnerability-step">
              <div className="iot-vulnerability-step-number">
                <span>01</span>
              </div>
              <div className="iot-vulnerability-step-content">
                <div className="iot-vulnerability-step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M10 12h4m-4 5h4M10 7h4m4 5h2m-2 6h2M18 6h2M4 12h2m-2 6h2M4 6h2\\"></path>
                      <rect x="6" y="2" rx="2" width="12" height="20"></rect>
                    </g>
                  </svg>
                </div>
                <h3 className="iot-vulnerability-step-title">
                  Firmware Analysis
                </h3>
                <p className="section-content">
                  Extract and reverse-engineer device firmware to identify
                  hardcoded credentials, backdoors, insecure cryptographic
                  implementations, and vulnerable libraries. Binary analysis
                  reveals hidden security flaws.
                </p>
              </div>
            </div>
            <div className="iot-vulnerability-step">
              <div className="iot-vulnerability-step-number">
                <span>02</span>
              </div>
              <div className="iot-vulnerability-step-content">
                <div className="iot-vulnerability-step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                      <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="iot-vulnerability-step-title">
                  Protocol Assessment
                </h3>
                <p className="section-content">
                  Deep packet inspection of communication protocols including
                  MQTT, CoAP, Zigbee, and Bluetooth. We identify authentication
                  bypasses, man-in-the-middle vulnerabilities, and insecure data
                  transmission.
                </p>
              </div>
            </div>
            <div className="iot-vulnerability-step">
              <div className="iot-vulnerability-step-number">
                <span>03</span>
              </div>
              <div className="iot-vulnerability-step-content">
                <div className="iot-vulnerability-step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="iot-vulnerability-step-title">
                  API &amp; Cloud Testing
                </h3>
                <p className="section-content">
                  Comprehensive assessment of cloud backends, mobile companion
                  apps, and REST APIs. Testing covers authorization flaws, data
                  leakage, injection attacks, and insecure direct object
                  references.
                </p>
              </div>
            </div>
            <div className="iot-vulnerability-step">
              <div className="iot-vulnerability-step-number">
                <span>04</span>
              </div>
              <div className="iot-vulnerability-step-content">
                <div className="iot-vulnerability-step-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="11"
                        rx="2"
                        ry="2"
                        width="18\\"
                        height="11\\"
                      ></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="iot-vulnerability-step-title">
                  Ecosystem Integration
                </h3>
                <p className="section-content">
                  Assess security implications of third-party integrations,
                  voice assistants, and ecosystem partnerships. Evaluate
                  privilege escalation, cross-device attacks, and supply chain
                  security risks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="iot-exploitation">
        <div className="iot-exploitation-container">
          <div className="iot-exploitation-header">
            <h2 className="section-title">
              Exploitation &amp; Validation Testing
            </h2>
            <p className="section-subtitle">
              Controlled exploitation to prove real-world impact and resilience
            </p>
          </div>
          <div className="iot-exploitation-grid">
            <div className="iot-exploitation-card">
              <div className="iot-exploitation-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="iot-exploitation-title">Hardware Exploitation</h3>
              <p className="section-content">
                JTAG/UART debugging interface exploitation, firmware extraction,
                chip-off analysis, and side-channel attacks to validate physical
                security controls.
              </p>
            </div>
            <div className="iot-exploitation-card">
              <div className="iot-exploitation-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iot-exploitation-title">Network Attacks</h3>
              <p className="section-content">
                Replay attacks, protocol fuzzing, botnet simulation, and
                denial-of-service testing against device communication channels
                and network infrastructure.
              </p>
            </div>
            <div className="iot-exploitation-card">
              <div className="iot-exploitation-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iot-exploitation-title">Authentication Bypass</h3>
              <p className="section-content">
                Testing default credentials, weak password policies, session
                management flaws, and multi-factor authentication bypasses
                across all access points.
              </p>
            </div>
            <div className="iot-exploitation-card">
              <div className="iot-exploitation-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10 12h4m-4 5h4M10 7h4m4 5h2m-2 6h2M18 6h2M4 12h2m-2 6h2M4 6h2\\"></path>
                    <rect x="6" y="2" rx="2" width="12" height="20"></rect>
                  </g>
                </svg>
              </div>
              <h3 className="iot-exploitation-title">Firmware Manipulation</h3>
              <p className="section-content">
                Custom firmware injection, bootloader vulnerabilities, secure
                boot bypasses, and update mechanism exploitation to validate
                device integrity protections.
              </p>
            </div>
            <div className="iot-exploitation-card">
              <div className="iot-exploitation-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5"></path>
                    <path d="m22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7m16 14a3 3 0 1 0 0-6a3 3 0 0 0 0 6"></path>
                    <circle r="3" cx="18" cy="18"></circle>
                    <path d="m22 22l-1.5-1.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iot-exploitation-title">Data Interception</h3>
              <p className="section-content">
                Wireless sniffing, traffic decryption, sensitive data exposure
                in logs, memory dumps, and unencrypted storage validation
                through active exploitation.
              </p>
            </div>
            <div className="iot-exploitation-card">
              <div className="iot-exploitation-icon">
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="iot-exploitation-title">
                Control System Takeover
              </h3>
              <p className="section-content">
                Command injection, privilege escalation, remote code execution,
                and complete device compromise to demonstrate worst-case attack
                scenarios and business impact.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="iot-hardening">
        <div className="iot-hardening-container">
          <div className="iot-hardening-layout">
            <div className="iot-hardening-image">
              <img
                alt="Smart home setup including smartphone and security devices against a vibrant pink background."
                src="https://images.pexels.com/photos/22610381/pexels-photo-22610381.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=600"
                loading="lazy"
                className="io-t-security-image"
              />
              <div className="iot-hardening-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
                <span>Secure Configuration</span>
              </div>
            </div>
            <div className="iot-hardening-content">
              <h2 className="io-t-security-thq-section-title-elm4 section-title">
                Security Hardening &amp; Implementation
              </h2>
              <p className="section-subtitle">
                Practical guidance for securing devices throughout their
                lifecycle
              </p>
              <div className="iot-hardening-steps">
                <div className="iot-hardening-step">
                  <div className="iot-hardening-step-header">
                    <div className="iot-hardening-step-number">
                      <span>01</span>
                    </div>
                    <h3 className="iot-hardening-step-title">
                      Secure Boot Configuration
                    </h3>
                  </div>
                  <p className="section-content">
                    Implement cryptographic verification of firmware integrity,
                    enable secure bootloaders, configure hardware root-of-trust,
                    and establish firmware signing processes to prevent
                    unauthorized code execution.
                  </p>
                </div>
                <div className="iot-hardening-step">
                  <div className="iot-hardening-step-header">
                    <div className="iot-hardening-step-number">
                      <span>02</span>
                    </div>
                    <h3 className="iot-hardening-step-title">
                      Network Segmentation
                    </h3>
                  </div>
                  <p className="section-content">
                    Isolate IoT devices on dedicated VLANs, implement firewall
                    rules, enable intrusion detection systems, and establish
                    zero-trust network access policies to limit lateral
                    movement.
                  </p>
                </div>
                <div className="iot-hardening-step">
                  <div className="iot-hardening-step-header">
                    <div className="iot-hardening-step-number">
                      <span>03</span>
                    </div>
                    <h3 className="iot-hardening-step-title">
                      Authentication Hardening
                    </h3>
                  </div>
                  <p className="section-content">
                    Eliminate default credentials, enforce strong password
                    policies, implement certificate-based authentication, enable
                    multi-factor authentication, and rotate cryptographic keys
                    regularly.
                  </p>
                </div>
                <div className="iot-hardening-step">
                  <div className="iot-hardening-step-header">
                    <div className="iot-hardening-step-number">
                      <span>04</span>
                    </div>
                    <h3 className="iot-hardening-step-title">
                      Encryption Implementation
                    </h3>
                  </div>
                  <p className="section-content">
                    Enable TLS 1.3 for all communications, implement end-to-end
                    encryption, secure data at rest with strong algorithms, and
                    establish proper key management infrastructure.
                  </p>
                </div>
                <div className="iot-hardening-step">
                  <div className="iot-hardening-step-header">
                    <div className="iot-hardening-step-number">
                      <span>05</span>
                    </div>
                    <h3 className="iot-hardening-step-title">
                      Update &amp; Patch Management
                    </h3>
                  </div>
                  <p className="section-content">
                    Establish automated update mechanisms, implement secure OTA
                    firmware delivery, maintain device inventory, monitor
                    vulnerability disclosures, and test patches before
                    deployment.
                  </p>
                </div>
                <div className="iot-hardening-step">
                  <div className="iot-hardening-step-header">
                    <div className="iot-hardening-step-number">
                      <span>06</span>
                    </div>
                    <h3 className="iot-hardening-step-title">
                      Monitoring &amp; Response
                    </h3>
                  </div>
                  <p className="section-content">
                    Deploy security monitoring tools, configure logging and
                    alerting, establish incident response procedures, conduct
                    regular security audits, and maintain security
                    documentation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="iot-ecosystem">
        <div className="iot-ecosystem-container">
          <div className="iot-ecosystem-header">
            <h2 className="section-title">Ecosystem Security Assessment</h2>
            <p className="section-subtitle">
              Comprehensive evaluation of authentication, encryption, and
              protocol resilience
            </p>
          </div>
          <div className="iot-ecosystem-grid">
            <div className="iot-ecosystem-card">
              <div className="iot-ecosystem-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.5 7.5l2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4m2-2l-9.6 9.6"></path>
                    <circle r="5.5" cx="7.5" cy="15.5"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="iot-ecosystem-card-title">
                Authentication Testing
              </h3>
              <p className="section-content">
                Comprehensive assessment of device authentication mechanisms,
                credential storage, token management, session handling, and
                authorization workflows across the entire ecosystem.
              </p>
              <div className="iot-ecosystem-card-tags">
                <span className="iot-ecosystem-tag">OAuth/OIDC</span>
                <span className="iot-ecosystem-tag">PKI</span>
                <span className="iot-ecosystem-tag">Biometric</span>
              </div>
            </div>
            <div className="iot-ecosystem-card">
              <div className="iot-ecosystem-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18\\"
                      height="11\\"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iot-ecosystem-card-title">Encryption Analysis</h3>
              <p className="section-content">
                Evaluation of cryptographic implementations, cipher suite
                selection, key generation and storage, certificate validation,
                and encryption protocols across device communications.
              </p>
              <div className="iot-ecosystem-card-tags">
                <span className="iot-ecosystem-tag">TLS 1.3</span>
                <span className="iot-ecosystem-tag">AES-256</span>
                <span className="iot-ecosystem-tag">PKI</span>
              </div>
            </div>
            <div className="iot-ecosystem-card">
              <div className="iot-ecosystem-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="iot-ecosystem-card-title">Protocol Resilience</h3>
              <p className="section-content">
                Deep testing of communication protocols including MQTT, CoAP,
                Zigbee, BLE, and proprietary protocols for resilience against
                attacks, fuzzing, and malformed data.
              </p>
              <div className="iot-ecosystem-card-tags">
                <span className="iot-ecosystem-tag">MQTT</span>
                <span className="iot-ecosystem-tag">CoAP</span>
                <span className="iot-ecosystem-tag">BLE</span>
              </div>
            </div>
            <div className="iot-ecosystem-card">
              <div className="iot-ecosystem-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="iot-ecosystem-card-title">API Security</h3>
              <p className="section-content">
                Thorough examination of REST/GraphQL APIs, rate limiting, input
                validation, authorization controls, and secure data handling in
                cloud and mobile backends.
              </p>
              <div className="iot-ecosystem-card-tags">
                <span className="iot-ecosystem-tag">REST</span>
                <span className="iot-ecosystem-tag">GraphQL</span>
                <span className="iot-ecosystem-tag">OWASP</span>
              </div>
            </div>
            <div className="iot-ecosystem-card">
              <div className="iot-ecosystem-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M3 20h7m4 0h7m-11 0a2 2 0 1 0 4 0a2 2 0 0 0-4 0m2-4v2m-4-1.996H6.657C4.085 16 2 13.993 2 11.517s2.085-4.482 4.657-4.482c.393-1.762 1.794-3.2 3.675-3.773c1.88-.572 3.956-.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486s-1.551 3.487-3.465 3.487H16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="iot-ecosystem-card-title">Cloud Integration</h3>
              <p className="section-content">
                Assessment of cloud service integrations, data sovereignty,
                access controls, logging and monitoring, multi-tenancy
                isolation, and third-party service security.
              </p>
              <div className="iot-ecosystem-card-tags">
                <span className="iot-ecosystem-tag">AWS IoT</span>
                <span className="iot-ecosystem-tag">Azure</span>
                <span className="iot-ecosystem-tag">GCP</span>
              </div>
            </div>
            <div className="iot-ecosystem-card">
              <div className="iot-ecosystem-card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="iot-ecosystem-card-title">Update Mechanisms</h3>
              <p className="section-content">
                Security review of firmware and software update processes,
                signature verification, rollback protection, secure delivery
                channels, and update authentication.
              </p>
              <div className="iot-ecosystem-card-tags">
                <span className="iot-ecosystem-tag">OTA</span>
                <span className="iot-ecosystem-tag">Signing</span>
                <span className="iot-ecosystem-tag">Integrity</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="io-t-security-thq-iot-cta-elm iot-cta">
        <div className="iot-cta-container">
          <div className="io-t-security-thq-iot-cta-card-elm iot-cta-card">
            <div className="iot-cta-icon">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h2 className="section-title">Secure Your IoT Ecosystem Today</h2>
            <p className="section-subtitle">
              Connect with our IoT security experts to discuss your device
              security challenges and receive a customized assessment plan
              tailored to your specific ecosystem.
            </p>
            <div className="iot-cta-actions">
              <a href="#contact">
                <div className="io-t-security-thq-btn-elm3 btn-primary btn-xl btn">
                  <span>Schedule Consultation</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="io-t-security-container2">
        <div className="io-t-security-container3">
          <Script
            html={`<script defer data-name="iot-scroll-animations">
(function(){
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const animateOnScroll = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }

  const observer = new IntersectionObserver(animateOnScroll, observerOptions)

  const cards = document.querySelectorAll(".iot-overview-card, .iot-exploitation-card, .iot-ecosystem-card, .iot-casestudies-card, .iot-hardening-step, .iot-compliance-item")

  cards.forEach((card) => {
    card.style.opacity = "0"
    card.style.transform = "translateY(20px)"
    card.style.transition = "opacity 0.5s ease, transform 0.5s ease"
    observer.observe(card)
  })

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    cards.forEach((card) => {
      card.style.opacity = "1"
      card.style.transform = "translateY(0)"
      card.style.transition = "none"
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default IoTSecurity
